import {render} from "@variocube/app-ui";
import React from "react";
import {App} from "./app";

render(<App />);
